module.exports = __webpack_public_path__ + "static/media/square_checkmark_active.435a4ac5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_active.svg
// module id = 39
// module chunks = 0